const Error = ({ message }) => {
  return <h3>{message}</h3>;
};

export default Error;
